import { HttpQueryConfig } from '../../core/model/HttpQueryConfig.model';

export const DashboardHttpQueryConfig: HttpQueryConfig = {
  GetItsmNetworkServiceIncidents: {
    key: 'GetItsmNetworkServiceIncidents',
    url: '/api/customers/{customerId}/itsm-network-service-incidents?sorting-name=lastUpdateTime&sorting-direction=descending&list-limit=5',
    errors: {}
  },
  GetItsmMaintenanceWorks: {
    key: 'GetItsmMaintenanceWorks',
    url: '/api/customers/{customerId}/itsm-maintenance-works?sorting-name=startTime&sorting-direction=descending&list-limit=5',
    errors: {},
  },
  GetL3ServiceStatusGroup: {
    key: 'GetL3ServiceStatusGroup',
    url: '/api/customers/{customerId}/l3-service-status-groups',
    errors: {},
  }
};
